import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
import '../InnerRefresh.css';

const RegulationsPage = () => {
  const { t, language } = useLanguage();
  const sections = [
    { id: 'eu-mica', title: 'euMicaTitle', subtitle: 'euMicaSubtitle', list: ['euMica1', 'euMica2', 'euMica3', 'euMica4'] },
    { id: 'au-apra', title: 'auApraTitle', subtitle: 'auApraSubtitle', list: ['auApra1', 'auApra2', 'auApra3'] },
    { id: 'au-asic', title: 'auAsicTitle', subtitle: 'auAsicSubtitle', paragraphs: ['auAsicIntro'], list: ['auAsic1', 'auAsic2'] },
    { id: 'canada', title: 'caTitle', paragraphs: ['caOsfi', 'caIiroc', 'caCsa'], list: ['caCsa1', 'caCsa2', 'caCsa3'] },
    { id: 'us-sec', title: 'usSecTitle', paragraphs: ['usSecDesc'] },
    { id: 'uk-fca', title: 'ukFcaTitle', paragraphs: ['ukFcaDesc'] }
  ];
  return (
    <div className="tb-inner" data-testid="regulations-page"><Header /><main>
      <section className="tb-inner-hero tb-container tb-inner-hero-compact"><h1>{language === 'pl' ? 'Regulacje finansowe' : 'Financial regulations'}</h1></section>
      <div className="tb-container tb-inner-body tb-inner-document-grid">
        <nav className="tb-inner-toc tb-document-toc" aria-label={language === 'pl' ? 'Spis treści' : 'Contents'}>{sections.map(section => <a key={section.id} href={`#${section.id}`}>{t(`regulationsPage.${section.title}`)}<ArrowUpRight size={15} aria-hidden="true" /></a>)}</nav>
        <article className="tb-inner-prose tb-document-prose">{sections.map(section => <section className="tb-inner-section" id={section.id} key={section.id}>
          <h2>{t(`regulationsPage.${section.title}`)}</h2>
          {section.subtitle && <p className="tb-document-subtitle">{t(`regulationsPage.${section.subtitle}`)}</p>}
          {section.paragraphs?.map(key => <p key={key}>{t(`regulationsPage.${key}`)}</p>)}
          {section.list && <ul>{section.list.map(key => <li key={key}>{t(`regulationsPage.${key}`)}</li>)}</ul>}
        </section>)}</article>
      </div>
    </main><Footer /></div>
  );
};
export default RegulationsPage;
